export default __webpack_public_path__ + "static/media/Maternityshoot.e1d6427d.webp";